<template>
  <div class="bottombar" :style="bottombarStyle">
    <div v-if="state.showScenes" :style="{'width': state.play ? '100vw!important' : 'calc(100vw - 42px)!important'}" style="height: 84px;text-align: left;border-top: 1px solid var(--color-22);" class="objs-div">
      <el-row>
        <el-button v-if="!state.play" :disabled="scenes.length <= 1" class="iconfont my-play" :title="$t('i.play')" @click="emit('startPlay')" />
        <el-button v-if="state.play" :disabled="scenes.length <= 1" class="iconfont my-stop" :title="$t('i.stop')" @click="emit('stopPlay')" />
        <el-popover v-model="animationSetShow" placement="top-start" offset="4" trigger="click">
          {{ $t('i.playRate', { rate: rate }) }}
          <el-slider v-model="rate" :min="1" :max="24" :show-tooltip="false" />
          {{ $t('i.playTimes') }} &nbsp;
          <el-radio-group v-model="loop">
            <el-radio :label="1">1</el-radio>
            <el-radio :label="2">2</el-radio>
            <el-radio :label="0">{{ $t('i.loop') }}</el-radio>
          </el-radio-group>
          <el-button slot="reference" :disabled="scenes.length <= 1" class="iconfont my-remain" :title="$t('i.animateSet')" />
        </el-popover>
        <el-button class="iconfont my-scenes-add" :title="$t('i.addScene')" @click="emit('addScene')" />
        <el-button :disabled="!scenes.length" class="iconfont my-copyparse" :title="$t('i.copyparse')" @click="emit('copyScene', [state.sceneIdx])" />
        <el-popconfirm v-if="scenes.length > 1" :title="$t('i.delScene')" cancel-button-type="Primary" placement="top" @confirm="emit('delScene', [state.sceneIdx])">
          <el-button slot="reference" class="iconfont my-delete" :title="$t('i.delete')" />
        </el-popconfirm>
      </el-row>
      <el-row class="padding4" style="border-top: 1px solid var(--color-1b);overflow-x: auto;">
        <div :style="{'width': scenes.length * 46 + 'px'}">
          <div v-for="(scene, idx) in scenes" :key="scene.id" :class="state.sceneIdx === idx ? 'select' : ''">
            <div class="obj-img" @click="emit('selectScene', [idx])">
              <scenes-preview
                :key="'scenes-preview:' + state.sceneId"
                :idx="idx"
                :file="file"
              />
            </div>
          </div>
        </div>
      </el-row>
    </div>
    <div v-show="!state.play" :style="toolbarStyle">
      <div style="width:460px;margin: 0 auto;">
        <el-dropdown v-if="file && file.type === 0" trigger="click" placement="top-start" @command="setPalette">
          <el-button class="iconfont my-palette" :disabled="!btnStatus.setPalette" :title="$t('i.setPalette')" />
          <el-dropdown-menu slot="dropdown" class="my-dropdown">
            <el-dropdown-item v-if="curObj.type === 'image'" command=""> {{ $t('i.primaryColors') }} <span class="float-right align-right" :class="curObj.paletteId === '' ? 'iconfont my-check' : ''" /></el-dropdown-item>
            <!-- <el-dropdown-item v-if="curObj.type === 'image'" command="64"> {{ $t('i.simplifiedColors') }}(64) <span class="float-right align-right" :class="curObj.paletteId === '64' ? 'iconfont my-check' : ''" /></el-dropdown-item> -->
            <!-- <el-dropdown-item v-if="curObj.type === 'image'" command="32"> {{ $t('i.simplifiedColors') }}(32) <span class="float-right align-right" :class="curObj.paletteId === '32' ? 'iconfont my-check' : ''" /></el-dropdown-item> -->
            <el-dropdown-item v-if="curObj.type === 'image'" command="16"> {{ $t('i.simplifiedColors') }} <span class="float-right align-right" :class="curObj.paletteId === '16' ? 'iconfont my-check' : ''" /></el-dropdown-item>
            <!-- <el-dropdown-item v-if="curObj.type === 'image'" command="8"> 8色 <span class="float-right align-right" :class="curObj.paletteId === '8' ? 'iconfont my-check' : ''" /></el-dropdown-item> -->
            <el-dropdown-item v-for="item in palette.opts" v-show="item.value !== 'default'" :key="item.value" :command="item.value">
              {{ item.label }}
              <span class="float-right align-right" :class="curObj.paletteId === item.value ? 'iconfont my-check' : ''" />
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown trigger="click" placement="top-start" @command="(e) => emit('setFillShape', [e])">
          <el-button class="iconfont my-shape" :disabled="!btnStatus.gridShape" :title="$t('i.shape')" />
          <el-dropdown-menu slot="dropdown" class="my-dropdown">
            <el-dropdown-item command="square"><i class="iconfont my-square-shape" /> {{ $t('i.square') }} <span class="float-right align-right" :class="curObj.fillShape === 'square' ? 'iconfont my-check' : ''" /></el-dropdown-item>
            <el-dropdown-item command="circle"> <i class="iconfont my-circle-shape" /> {{ $t('i.round') }} <span class="float-right align-right" :class="curObj.fillShape === 'circle' ? 'iconfont my-check' : ''" /></el-dropdown-item>
            <!-- <el-dropdown-item command="triangle"> <i class="iconfont my-triangle-shape" /> {{ $t('i.triangl') }} <span class="float-right align-right" :class="curObj.fillShape === 'triangle' ? 'iconfont my-check' : ''" /></el-dropdown-item> -->
            <el-dropdown-item command=""> <i class="iconfont my-square-full" /> {{ $t('i.default') }} <span class="float-right align-right" :class="curObj.fillShape === '' ? 'iconfont my-check' : ''" /></el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button class="iconfont my-colorfilter" :disabled="!btnStatus.colorFilter" :title="$t('i.hue')" @click="openColorFilter()" />
        <el-button class="iconfont my-denoise" :disabled="!btnStatus.denoise" :title="$t('i.noiseReduction')" @click="openDenoise" />
        <el-popover v-model="mngColorShow" placement="top-start" offset="4" popper-class="padding4" width="260" trigger="click">
          <div class="my-title-bar padding-left8 padding-bottom4" style="border-bottom: 1px solid var(--color-22);">
            {{ $t('i.objColors') }} <span v-if="state.objColors.count">({{ state.objColors.count > 128 ? '128+' : state.objColors.count }})</span>
            <el-button :type="state.colorOrder === 'desc' ? 'light' : ''" class="iconfont my-sort-desc padding4 float-right" :title="$t('i.reverse')" @click="toggleColorOrder" />
            <el-button class="iconfont my-denoise padding4 margin-right4 float-right" :disabled="!btnStatus.denoise" :title="$t('i.noiseReduction')" @click="openDenoise()" />
          </div>
          <div class="my-colors">
            <div :style="{ width: '100%', height: '206px', 'overflow-x': 'hidden', 'overflow-y': 'auto'}">
              <el-row v-for="(color, idx) in state.objColors.colors" :key="'in_' + idx">
                <el-col :span="3"><div class="preview" :title="color[0].toUpperCase()" :style="{ background: color[0] }" /></el-col>
                <!-- <el-col :span="7" :title="color[0].toUpperCase()">
                  <span v-if="editColor.idx !== idx" @click="toggleColorEditer(idx, true)">{{ color[0].toUpperCase() }}</span>
                  <el-input v-if="editColor.idx === idx" v-model.trim="editColor.newColor" type="input" maxlength="7" onkeyup="this.value = this.value.replace(/[^#0-9a-fA-F.]/g,'')" @blur="changeColor(idx)" />
                </el-col> -->
                <el-col :span="7" :title="'#' + (cids[color[0].toUpperCase()] || color[0].replace('#', ''))">
                  #{{ cids[color[0].toUpperCase()] || color[0].replace('#', '') }}
                </el-col>
                <el-col :span="6" :title="$t('i.colorCount')">x{{ color[1] }}</el-col>
                <el-col :span="4" :title="$t('i.changeColor')">
                  <i class="iconfont my-change main-color" @click="(event) => {emit('toggleColorPicker', [event, 'change-color', [color[0].toUpperCase()]])}" />
                </el-col>
                <el-col :span="4" :title="$t('i.deleteColor')" class="align-right">
                  <el-button :disabled="state.objColors.count <= 2" class="iconfont my-delete padding4 margin0" :title="$t('i.delete')" @click="emit('deleteObjColor', [color[0]])" />
                </el-col>
              </el-row>
            </div>
          </div>
          <el-button slot="reference" class="iconfont my-color-drop" :disabled="!btnStatus.mngColors" :title="$t('i.manageColors')" />
        </el-popover>
        <!-- <el-popconfirm title="确定清除对象吗？" cancel-button-type="Primary" placement="top" @confirm="emit('clear')">
          <el-button slot="reference" class="iconfont my-clear" :disabled="!btnStatus.clear" title="清除对象" />
        </el-popconfirm> -->
        <el-popconfirm :title="$t('i.ifRestoreImage')" cancel-button-type="Primary" placement="top" @confirm="emit('restore')">
          <el-button slot="reference" class="iconfont my-restore" :disabled="!btnStatus.restore" :title="$t('i.restoreImage')" />
        </el-popconfirm>
        <el-dropdown trigger="click" placement="top-start" size="medium" @command="(e) => emit('rotate', [e])">
          <el-button class="iconfont my-rotate-left" :disabled="!btnStatus.rotate" :title="$t('i.rotate')" />
          <el-dropdown-menu slot="dropdown" class="my-dropdown">
            <el-dropdown-item :command="'w'" class="iconfont my-rotate-right"> {{ $t('i.rotateRight') }}</el-dropdown-item>
            <el-dropdown-item :command="'i'" class="iconfont my-rotate-left"> {{ $t('i.rotateLeft') }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown trigger="click" placement="top-start" @command="(e) => emit('flip', [e])">
          <el-button class="iconfont my-flip-h" :disabled="!btnStatus.flip" :title="$t('i.flip')" />
          <el-dropdown-menu slot="dropdown" class="my-dropdown">
            <el-dropdown-item :command="'h'" class="iconfont my-flip-h"> {{ $t('i.flipH') }}</el-dropdown-item>
            <el-dropdown-item :command="'v'" class="iconfont my-flip-v"> {{ $t('i.flipV') }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown trigger="click" placement="top-start" @command="(e) => emit('setLayer', [e])">
          <el-button class="iconfont my-lay-down" :title="$t('i.sort')" :disabled="!btnStatus.layTop && !btnStatus.layBottom && !btnStatus.layUp && !btnStatus.layDown" />
          <el-dropdown-menu slot="dropdown" class="my-dropdown">
            <el-dropdown-item :command="'top'" class="iconfont my-lay-top" :disabled="!btnStatus.layTop"> {{ $t('i.layTop') }}</el-dropdown-item>
            <el-dropdown-item :command="'bottom'" class="iconfont my-lay-bottom" :disabled="!btnStatus.layBottom"> {{ $t('i.layBottom') }}</el-dropdown-item>
            <el-dropdown-item :command="'+'" class="iconfont my-lay-up" :disabled="!btnStatus.layUp"> {{ $t('i.layUp') }}</el-dropdown-item>
            <el-dropdown-item :command="'-'" class="iconfont my-lay-down" :disabled="!btnStatus.layDown"> {{ $t('i.layDown') }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown trigger="click" placement="top-start" @command="(e) => emit('align', [e])">
          <el-button class="iconfont my-align-left" :title="$t('i.align')" :disabled="!btnStatus.alignLeft && !btnStatus.alignCenter && !btnStatus.alignRight && !btnStatus.alignTop && !btnStatus.alignMiddle && !btnStatus.alignBottom && !btnStatus.alignSpaceH && !btnStatus.alignSpaceV" />
          <el-dropdown-menu slot="dropdown" class="my-dropdown">
            <el-dropdown-item :command="'left'" class="iconfont my-align-left" :disabled="!btnStatus.alignLeft"> {{ $t('i.alignLeft') }}</el-dropdown-item>
            <el-dropdown-item :command="'center'" class="iconfont my-align-center" :disabled="!btnStatus.alignCenter"> {{ $t('i.alignCenter') }}</el-dropdown-item>
            <el-dropdown-item :command="'right'" class="iconfont my-align-right" :disabled="!btnStatus.alignRight"> {{ $t('i.alignRight') }}</el-dropdown-item>
            <el-dropdown-item :command="'top'" class="iconfont my-align-top" :disabled="!btnStatus.alignTop"> {{ $t('i.alignTop') }}</el-dropdown-item>
            <el-dropdown-item :command="'middle'" class="iconfont my-align-middle" :disabled="!btnStatus.alignMiddle"> {{ $t('i.alignMiddle') }}</el-dropdown-item>
            <el-dropdown-item :command="'bottom'" class="iconfont my-align-bottom" :disabled="!btnStatus.alignBottom"> {{ $t('i.alignBottom') }}</el-dropdown-item>
            <el-dropdown-item :command="'spaceH'" class="iconfont my-align-space-h" :disabled="!btnStatus.alignSpaceH"> {{ $t('i.alignSpaceH') }}</el-dropdown-item>
            <el-dropdown-item :command="'spaceV'" class="iconfont my-align-space-v" :disabled="!btnStatus.alignSpaceV"> {{ $t('i.alignSpaceV') }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button class="iconfont my-group" :disabled="!btnStatus.group" :title="$t('i.group')" @click="emit('group')" />
        <el-button class="iconfont my-ungroup" :disabled="!btnStatus.ungroup" :title="$t('i.ungroup')" @click="emit('ungroup')" />
        <el-button class="iconfont my-merge" :disabled="!btnStatus.merge" :title="$t('i.merge')" @click="emit('merge')" />
        <!-- <el-button class="iconfont my-eye-off" :disabled="!btnStatus.hide" :title="$t('i.hide')" @click="() => emit('hideSelectObjs')" />
        <el-button :disabled="!btnStatus.lock" class="iconfont my-lock" :title="$t('i.lock')" @click="() => emit('lockSelectObjs')" />
        <el-button :disabled="!btnStatus.unlock" class="iconfont my-unlock" :title="$t('i.unlock')" @click="() => emit('unlockSelectObjs')" />
        <el-button class="iconfont my-copyparse" :disabled="!btnStatus.copy" :title="$t('i.copy')" @click="() => emit('copyAndParse', [state.objIdx])" />
        <el-button class="iconfont my-delete" :disabled="!btnStatus.del" :title="$t('i.delete')" @click="() => emit('delete', [false])" /> -->
      </div>
    </div>
    <div v-if="!isDesktop" v-show="!state.play && state.showPalette && !view.resource.show" class="foot_palette" style="width: calc(100vw - 42px);overflow-x: auto;text-align: left;border-top: 1px solid var(--color-1b);">
      <palette ref="palette" v-model="state.color[0]" :view="view" :state="state" :can-remove="false" :palette-id="curPaletteId" @receive="handle" />
    </div>
  </div>
</template>
<script>
import { mixins } from '@/mixins/common'
import conf from '@/js/conf/conf'
import palette from '@/components/palette'
import scenesPreview from '@/components/scenesPreview'
export default {
  components: {
    palette,
    scenesPreview
  },
  mixins: [mixins],
  props: {
    tmp: {
      type: Object,
      default() {
        return {}
      }
    },
    curObj: {
      type: Object,
      default() {
        return {}
      }
    },
    palette: {
      type: Object,
      default() {
        return {}
      }
    },
    curPaletteId: {
      type: String,
      default() {
        return 'brickfy'
      }
    },
    editColor: {
      type: Object,
      default() {
        return {}
      }
    },
    btnStatus: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    const filter = {
      // 色调
      hue: 0,
      // 饱和度
      saturation: 0,
      // 色明度
      value: 0,
      // 亮度
      brightness: 0,
      // 对比度
      contrast: 0
    }
    return { cids: {}, animationSetShow: false, mngColorShow: false, rate: 12, loop: 0, opts: { filter: filter }}
  },
  computed: {
    viewLeftSideWidth() {
      return this.view.mainLeftSide ? (this.view.mainLeftSideWidth + this.view.leftSideWidth) : this.view.leftSideWidth
    },
    // 右侧操作栏宽度
    rightSideWidth() {
      return this.view.rightSide ? (this.view.rightSideWidth + this.view.rightToggleWidth) : this.view.rightToggleWidth
    },
    bottombarStyle() {
      let style = {}
      if (this.isDesktop) {
        style = 'width: calc(100vw - ' + this.viewLeftSideWidth + 'px - ' + this.rightSideWidth + 'px);'
      } else {
        style = { 'width': this.state.play ? '100vw!important' : '', 'left': this.state.play ? '' : (this.view.rightToolBar ? '' : '40px') }
      }
      return style
    },
    toolbarStyle() {
      let style = 'height: 40px;overflow-x: auto;text-align: left;padding-top: 3px;border-top: 1px solid var(--color-1b);'
      if (this.isDesktop) {
        style = style + 'width: calc(100vw - ' + this.viewLeftSideWidth + 'px - ' + this.rightSideWidth + 'px);'
      } else {
        style = style + 'width: calc(100vw - 42px);'
      }
      return style
    }
  },
  watch: {
    'rate': {
      handler() {
        this.emit('setRateAndLoop', [this.rate, this.loop])
      }
    },
    'loop': {
      handler() {
        this.emit('setRateAndLoop', [this.rate, this.loop])
      }
    },
    'mngColorShow': {
      handler() {
        if (this.mngColorShow) {
          this.getObjColors()
        }
      }
    }
  },
  methods: {
    setPalette(e) {
      this.emit('setPalette', [e])
      // const colorIdsObj = conf.getColorIds(this.file.paletteId)
      const colorIdsObj = conf.getCids(this.file.paletteId)
      this.cids = colorIdsObj.colorIds
    },
    // 编辑颜色代码
    toggleColorEditer(i, edit) {
      this.editColor['color'] = (this.state.objColors.colors[i] && this.state.objColors.colors[i][0]) ? this.state.objColors.colors[i][0] : ''
      this.editColor['newColor'] = this.editColor['color']
      this.editColor['idx'] = i
      if (!edit) {
        this.editColor.color = ''
        this.editColor.newColor = ''
        this.editColor.idx = -1
      }
    },
    // 更换颜色
    changeColor(i) {
      const color = this.editColor['color'] || ''
      const newColor = this.editColor['newColor'] || ''
      if (/^#([0-9a-f]{6})$/i.test(newColor)) {
        this.emit('changeObjColor', [color, newColor])
      } else {
        if (this.state.objColors.colors[i] && this.state.objColors.colors[i][0]) this.state.objColors.colors[i][0] = color
      }
      setTimeout(() => {
        this.toggleColorEditer(i, false)
      }, 100)
    },
    setColors(palColors) {
      this.$refs['palette'] && this.$refs['palette'].setColors(palColors)
    },
    openDenoise() {
      const fn = () => {
        this.emit('denoise')
      }
      this.emit('openPop', [{ title: this.$t('i.noiseReduction'), type: 'denoise', fn: fn }])
    },
    openColorFilter() {
      const fn = () => {
        this.emit('colorFilter')
      }
      this.emit('openPop', [{ title: this.$t('i.hue'), type: 'colorFilter', fn: fn }])
    },
    toggleColorOrder() {
      if (this.state.colorOrder === 'asc') {
        this.state.colorOrder = 'desc'
      } else {
        this.state.colorOrder = 'asc'
      }
      this.getObjColors(this.state.colorOrder)
    },
    // 获取对象颜色表
    getObjColors(orderby = 'asc') {
      this.emit('getObjColors', orderby)
    }
  }
}
</script>
